import { useEffect } from 'react';
import type { State } from '../state';
import { AppId } from '../../../ApplicationWrapper.types';
import type { ConsoleLogger, ProductName } from '../types';

// FIXME: remove along with usage once possible
const activeProductAppIdMap: Partial<Record<ProductName, AppId>> = {
  programmableMedia: AppId.MediaAPI,
  digitalAssetManagement: AppId.DigitalAssetManagement,
  accountSettings: AppId.Settings,
  video: AppId.Video,
  mediaFlows: AppId.MediaFlows,
};

export const useStoreActiveProductEnvironmentExternalId = ({
  state,
  consoleLogger,
  localStorageClient,
}: {
  localStorageClient: Storage;
  consoleLogger: ConsoleLogger;
  state: State;
}) => {
  const activeProductName = state.applicationStatus === 'ready' ? state.activeProductName : undefined;
  const productEnvironment = state.applicationStatus === 'ready' ? state.productEnvironment : undefined;
  const impersonationActive = state.applicationStatus === 'ready' ? state.isImpersonationActive : undefined;

  useEffect(() => {
    if (activeProductName && productEnvironment && !impersonationActive) {
      const activeProductAppId = activeProductAppIdMap[activeProductName];
      // FIXME: deprecated key also used by session-service, move to unicorn-owned one once session service is absorbed
      localStorageClient.setItem(`cld-${activeProductAppId}-current-customer`, productEnvironment.externalId);

      consoleLogger.debug('storage', 'Updated saved active product environment external id', {
        key: `cld-${activeProductAppId}-current-customer`,
        newValue: productEnvironment.externalId,
      });
    }
  }, [activeProductName, productEnvironment, consoleLogger, localStorageClient, impersonationActive]);
};
